export const FETCH_PRODUCT_SUPPORT_DOCUMENTS_SUCCESS = 'FETCH_PRODUCT_SUPPORT_DOCUMENTS_SUCCESS'
export const GET_RELATED_PRODUCT_SUPPORT_DOCUMENTS_SUCCESS = 'GET_RELATED_PRODUCT_SUPPORT_DOCUMENTS_SUCCESS'
export const GET_PRODUCT_SUPPORT_DOCUMENT_SUCCESS = 'GET_PRODUCT_SUPPORT_DOCUMENT_SUCCESS'
export const ADD_PRODUCT_SUPPORT_DOCUMENT_SUCCESS = 'ADD_PRODUCT_SUPPORT_DOCUMENT_SUCCESS'
export const UPDATE_PRODUCT_SUPPORT_DOCUMENT_SUCCESS = 'UPDATE_PRODUCT_SUPPORT_DOCUMENT_SUCCESS'
export const DELETE_PRODUCT_SUPPORT_DOCUMENT_SUCCESS = 'DELETE_PRODUCT_SUPPORT_DOCUMENT_SUCCESS'

export const API_REQUEST_START = 'API_REQUEST_START'
export const API_REQUEST_FAIL = 'API_REQUEST_FAIL'
